import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
import { FadeUp } from './MaskReveal';
import { TESTIMONIAL } from '../../lib/site-data';

export default function Testimonial() {
  return (
    <section
      id="testimonial"
      data-testid="testimonial-section"
      className="relative bg-ink-900 py-20 md:py-28 overflow-hidden"
    >
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-[420px] w-[420px] rounded-full bg-signal-500/10 blur-[140px]" />

      <div className="container-editorial relative">
        <FadeUp>
          <span className="eyebrow">05 — In their words</span>
        </FadeUp>

        <div className="relative mt-10 md:mt-14 max-w-5xl">
          <motion.span
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 0.12, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
            className="absolute -top-16 -left-4 md:-top-24 md:-left-10 font-serif italic text-white leading-none select-none"
            style={{ fontSize: 'clamp(180px, 22vw, 320px)' }}
          >
            “
          </motion.span>

          <FadeUp delay={0.15}>
            <blockquote
              data-testid="testimonial-quote"
              className="relative display-heading text-white text-xl sm:text-2xl md:text-[26px] lg:text-[30px] leading-[1.35] tracking-tight text-balance max-w-4xl"
              style={{ letterSpacing: '-0.015em', fontWeight: 500 }}
            >
              {TESTIMONIAL.quote}
            </blockquote>
          </FadeUp>

          <FadeUp delay={0.3}>
            <div className="mt-10 md:mt-14 flex flex-col md:flex-row md:items-center md:justify-between gap-6 pt-8 border-t border-white/10">
              <div className="flex items-center gap-5">
                <span className="flex items-center justify-center h-12 w-12 rounded-full border border-white/15">
                  <Quote className="h-4 w-4 text-signal-500" />
                </span>
                <div>
                  <p className="display-heading text-white text-xl" data-testid="testimonial-author">
                    {TESTIMONIAL.author}
                  </p>
                  <p className="text-white/55 text-sm mt-0.5">
                    {TESTIMONIAL.role} · <span className="text-white/80">{TESTIMONIAL.company}</span>
                  </p>
                </div>
              </div>
              <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-white/40">
                7 years — and counting
              </p>
            </div>
          </FadeUp>
        </div>
      </div>
    </section>
  );
}
